/* eslint react/no-danger: 0 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Loading } from 'rp-react-table';

class Weatherbys extends PureComponent {
    constructor(props) {
        super(props);

        const { weatherbysUid } = this.props;
        this.state = {
            weatherbysInfo: '',
            loading: weatherbysUid,
        };
    }

    componentDidMount() {
        const { type, weatherbysUid } = this.props;
        if (this.state.loading) {
            axios.get(`horse/weatherbys/${weatherbysUid}/${type}`)
                .then(({ data }) => this.setState({
                    ...data,
                    loading: false,
                }))
                .catch(() => this.setState({ loading: false }));
        }
    }

    render() {
        const { weatherbysInfo, loading } = this.state;
        const { className, title, weatherbysUid } = this.props;
        return weatherbysUid ? (
            <div>
                { loading && <Loading /> }
                { weatherbysInfo && (

                    <div className="hp-weatherbys">
                        {title && <h2 className="hp-weatherbys__title">{title}</h2>}
                        <div
                            className={className}
                            dangerouslySetInnerHTML={{ __html: weatherbysInfo }}
                        />
                    </div>
                ) }
            </div>
        ) : null;
    }
}

Weatherbys.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string.isRequired,
    weatherbysUid: PropTypes.string,
};

export default Weatherbys;



// WEBPACK FOOTER //
// ./src/js/shared/Weatherbys.jsx